import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import useGetTotalEatenBaitLineChart from 'hooks/Analitics/SBSCharts/1_TotalEatenBaitLineChart/useGetTotalEatenBaitChartData';
import { vulsPeriodLineChartOptions } from 'pages/ObjectAnalitics/SBSCharts/1TotalEatenBaitLineChart/chartOptions';

interface Props {
  slug: string;
  startDate: string;
  endDate: string;
  zoom?: boolean;
}

interface ChartData {
  week_or_month_name: string[];
  amount: number[];
}

export const SBSChart: React.FC<Props> = ({ slug, endDate, startDate, zoom = true }) => {
  const { data } = useGetTotalEatenBaitLineChart(slug, 'CUSTOM', 'day', startDate, endDate);
  const { t } = useTranslation();
  const [chartData, setChartData] = useState<ChartData>({
    week_or_month_name: [],
    amount: [],
  });

  useEffect(() => {
    if (data) {
      const week_or_month_name = data.map((item: any) => item.week_or_month_name);
      const amount = data.map((item: any) => item.amount);

      setChartData({ week_or_month_name, amount });
    }
  }, [data]);

  const chartOptions = vulsPeriodLineChartOptions(chartData, t, 'Total bait eaten', zoom);

  return (
    <div className="position-relative">
      <ReactApexChart options={chartOptions} series={chartOptions.series} type="area" height={350} />
    </div>
  );
};
